export const XLSX_TYPE = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel", ".xls", ".xlsx", ".csv"];